module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/core-js/modules/_is-object.js
// module id = 31
// module chunks = 168707334958949